import { IAvailableDaysFormat } from '../../../api/client';

const CALENDAR_STORAGE_KEY = 'modal-high-blocked-days-closed';
const HIDE_MODAL_DURATION = 7 * 24 * 60 * 60 * 1000;

export const getStorageItemKey = (propertyId: string | number | undefined) => `${CALENDAR_STORAGE_KEY}-${propertyId}`;

/**
 * Sets a localStorage item with the given propertyId as the key and a value
 * representing the date when the modal was closed
 *
 * @param propertyId - The unique identifier for the property.
 */
export const storeLocallyCloseModalDate = (propertyId: string | number | undefined ) => {
	const now = new Date();
	localStorage.setItem(getStorageItemKey(propertyId), now.toISOString());
};

/**
 * Check if the modal was seen recently by getting the stored item
 * @param propertyId
 */
const wasModalSeenRecently = (propertyId: string | number | undefined) => {
	const storageDate = localStorage.getItem(getStorageItemKey(propertyId));
	if (storageDate) {
		const stored = new Date(storageDate);
		const now = new Date();
		return now.getTime() - stored.getTime() < HIDE_MODAL_DURATION;
	}
	return false;
};

/**
 * Check the storage items to see if it should show the modal or not
 * If the item exist and the date is older than our threshold, remove the item and return true
 * If the item does not exist, return true
 * If the item exists and the date is not older than our threshold, return false
 *
 * @param propertyId
 * @param availabilityValidity
 * @returns boolean
 */
export const isModalShowable = (propertyId: string | number | undefined, availabilityValidity: IAvailableDaysFormat ) => {
	const hasHighNumberOfBlockedDays = (availabilityValidity?.blockedDays || 0) > 182;
	const hasModalBeenSeenRecently = wasModalSeenRecently(propertyId);
	return hasHighNumberOfBlockedDays && !hasModalBeenSeenRecently;
};
